/* @flow */

import React from 'react';
import classNames from 'classnames';

import Tappable from './Tappable';

type Option = {
  label: string,
  value: mixed
};

type Props = {
  label?: string,
  className?: string,
  onChange: (val: mixed) => void,
  options: Option[],
  value: mixed,
  size?: 'small' | 'default'
};

function ButtonToggle({ className, label, onChange, options, value, size }: Props) {
  return (
    <div className={classNames('form-field-group', className)}>
      {label && <div className="form-input-label">{label}</div>}
      <div className="toggle-buttons toggle-buttons__light">
        {options.map(opt => (
          <Tappable
            key={opt.value}
            className={classNames('toggle-button', {
              'toggle-button-active': opt.value === value,
              'toggle-button__small': size === 'small'
            })}
            onTap={() => onChange(opt.value)}
          >
            {opt.label}
          </Tappable>
        ))}
      </div>
    </div>
  );
}

ButtonToggle.defaultProps = {
  className: undefined,
  label: undefined,
  size: 'default'
};

export default ButtonToggle;
